<template>
  <div>
    <p>
      This service has been discontinued.
      Please contact your coach,
      as they are managing your engagement through the GCG Coaching Tools application.
      If you have any additional questions, please email
      <a href="mailto:support@globalcoachgroup.com">support@globalcoachgroup.com.</a>
    </p>
    <p class="logout">
      <el-button
        type="primary"
        round
        @click="logoutRedirect"
      >
        {{ $t('common.logout') }}
      </el-button>
    </p>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'BlurDeprecated',

  methods: {
    ...mapActions('user', [
      'logout',
    ]),

    async logoutRedirect() {
      await this.logout();
      this.$router.push({ name: 'login' })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped lang="scss">
  .logout {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 0;
  }
</style>
